module.exports = " <div class=sent-popup v-if=mailSent> <div class=sent-popup__block> <p class=sent-popup__text>You will receive the requested file(s) via email.</p> <a @click=close class=simple-button>Close</a> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/shared/SentPopup.vue
// module id = 176
// module chunks = 0